const customAudienceAppend = ({ commit }, audience = null) => {
  commit("CUSTOM_AUDIENCE_APPEND", audience)
}

const customAudienceRemove = ({ commit }, index) => {
  commit("CUSTOM_AUDIENCE_REMOVE", index)
}

const customAudienceUpdate = ({ commit }, { audience, index }) => {
  commit("CUSTOM_AUDIENCE_UPDATE", { audience, index })
}

const excludedCustomAudienceAppend = ({ commit }, audience = null) => {
  commit("EXCLUDED_CUSTOM_AUDIENCE_APPEND", audience)
}

const excludedCustomAudienceRemove = ({ commit }, index) => {
  commit("EXCLUDED_CUSTOM_AUDIENCE_REMOVE", index)
}

const excludedCustomAudienceUpdate = ({ commit }, { audience, index }) => {
  commit("EXCLUDED_CUSTOM_AUDIENCE_UPDATE", { audience, index })
}

export {
  customAudienceAppend,
  customAudienceRemove,
  customAudienceUpdate,
  excludedCustomAudienceAppend,
  excludedCustomAudienceRemove,
  excludedCustomAudienceUpdate,
}
